import React, { useState, useEffect } from "react";
// import "./Managecountry.css";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import {
  Autocomplete,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CommonButton from "../../../../Componants/Common/Button";
import HeaderNavigation from "../../../../Componants/Common/header Navigation/HeaderNavigation";
import Subheader from "../../../../Componants/Common/Subheader";
import config from "../../../../Componants/Common/config";
import toast, { Toaster } from "react-hot-toast";
// import { library } from "@fortawesome/fontawesome-svg-core";
import {
  userByEntityId,
  changeAdminPassword,
} from "../../../../API Service/apiService";
import Loader from "../../../../Componants/Loader/Loader";
import DynamicTabs from "../../../../components/DynamicTabs";

const ChangeAdminPassword = ({ isSidebarCollapsed }) => {
  const [sidebarClass, setSidebarClass] = useState(
    isSidebarCollapsed ? "collapsed" : "expanded"
  );

  useEffect(() => {
    setSidebarClass(isSidebarCollapsed ? "collapsed" : "expanded");
  }, [isSidebarCollapsed]);

  const [page, setPage] = useState(1);
  const pageSize = config.pageSize;
  const [value, setValue] = React.useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  ////////////////////////
  const [entityType, setEntityType] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(false);

  const handleFetchUsers = async (type) => {
    console.log("Fetching users for entityType:", type);
    setLoadingUsers(true);
    try {
      const data = await userByEntityId({ entityType: type });
      console.log("API Response:", data.data.users);
      setUsers(data.data.users || []);
      // toast.success("Users loaded successfully!");
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to fetch users.");
      // alert("Failed to fetch users.");
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleChangePassword = async () => {
    if (!entityType || !selectedUser || !newPassword) {
      toast.error("Please fill in all fields.");
      // alert("Please fill in all fields.");
      return;
    }
    setLoading(true);
    try {
      await changeAdminPassword({
        entityType,
        UserId: selectedUser._id,
        newPassword,
      });
      toast.success("Password changed successfully!");
      setNewPassword("");
      setUsers([]);
    } catch (error) {
      toast.error("Failed to change password.");
      // alert("Failed to change password.");
    } finally {
      setLoading(false);
      setUsers([]);
      setSelectedUser(null);
    }
  };

  return (
    // <div
    //   className={`managecountry-container ${
    //     isSidebarExpanded ? "expanded" : "collapsed"
    //   }`}
    // >
    <div className={`managecountry-container ${sidebarClass}`}>
      <HeaderNavigation value={"Change Password Admin"} />
      <DynamicTabs />
      <div className="autocompleteform-managecountry">
        <div className="line-managecountry">
          <div className="textinput-managecountry">
            <Autocomplete
              id="country-autocomplete"
              options={["serviceCenter", "engineer"]}
              onChange={(e, value) => {
                setEntityType(value);
                handleFetchUsers(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Entity Type"
                  variant="standard"
                  placeholder="Select Entity Type"
                />
              )}
            />
          </div>
          <div className="textinput-managecountry">
            {/* <Autocomplete
              id="country-autocomplete"
              options={users}
              getOptionLabel={(option) => option.username || ""}
              onChange={(e, value) => setSelectedUser(value)}
              loading={loadingUsers}
              renderInput={(params) => (
                <TextField {...params} label="User" variant="standard"    placeholder="Select User"

                />
              )}
            /> */}
            <Autocomplete
              options={users}
              getOptionLabel={(option) =>
                option.serviceCenter || `${option.firstName} ${option.lastName}`
              }
              onChange={(e, value) => setSelectedUser(value)}
              loading={loadingUsers}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="User"
                  variant="standard"
                  placeholder="Select User"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingUsers ? <CircularProgress size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </div>
          <div className="textinput-managecountry"></div>
          <div className="textinput-managecountry"></div>
        </div>
        <div className="line-managecountry">
          <div className="textinput-managecountry">
            <TextField
              style={{ width: "100%" }}
              id="countryName"
              label="New Password"
              variant="standard"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
        </div>

        <div className="button-managecountry">
          <span className="buttons-managecountry-span">
            <CommonButton
              name={"Change Password"}
              handleOnClick={handleChangePassword}
            />
          </span>
        </div>
      </div>
      <Toaster />
      {loading && <Loader />}
    </div>
  );
};

export default ChangeAdminPassword;
